export default "__VITE_ASSET__BpA4p5fP__"